module.exports = __webpack_public_path__ + "static/0222-8a3fc4d6f94415a9086612a9e1792bba.png";